import { getStringBytes } from '@/scripts/tools/utils';

const validate = {
  getTagsErrorMsg(tags) {
    let result = '';
    const reg = /^(项目|project|qcs:)/;

    const pluck = (objs, str) => {
      let res = [];
      res = objs.map(item => item[str]);
      return res;
    };

    tags.forEach(obj => {
      if (!obj.Key || !obj.Value) {
        result = window.lang.t('core.PleaseEnterKeyAndValue');
        return false;
      }
      if (reg.test(obj.Key.toLowerCase())) {
        result = window.lang.t('core.EnterProductError');
        return false;
      }
      if (getStringBytes(obj.Key) > 127) {
        result = window.lang.t('core.MaxKey127');
        return false;
      }
      if (getStringBytes(obj.Value) > 255) {
        result = window.lang.t('core.MaxKey255');
        return false;
      }
      return true;
    });

    if (Array.from(new Set(pluck(tags, 'Key'))).length < pluck(tags, 'Key').length) {
      result = window.lang.t('core.KeyRepeat');
    }
    return result;
  },
};

export default validate;
